import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { makeQueryClient } from "@/lib/queryClient";
import "@/index.css";
import "@/buildInfo";
import App from "@/App";

// Self-heal stale caches: a leftover service worker from an earlier build can
// intercept and fail API requests in a normal browser tab (incognito has none,
// which is why it "works" there). On load, unregister any service workers,
// purge their caches, and reload once so requests go straight to the network.
(function cleanupStaleServiceWorkers() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker.getRegistrations()
    .then((regs) => {
      if (!regs.length) return;
      return Promise.all(regs.map((r) => r.unregister()))
        .then(() => (window.caches?.keys ? caches.keys().then((ks) => Promise.all(ks.map((k) => caches.delete(k)))) : null))
        .then(() => {
          if (!sessionStorage.getItem("sw_cleaned")) {
            sessionStorage.setItem("sw_cleaned", "1");
            window.location.reload();
          }
        });
    })
    .catch(() => {});
})();

// When a kept figure is asked again is decided in lib/queryClient.js. (ZEN-735)
const queryClient = makeQueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
